import { Event, Watch, EventEmitter, Component, Prop, Element, Host, h } from '@stencil/core';
import { Color, SliderInputChangeEvent } from '../../../interface';
import { createColorClasses } from '../../../utils/theme';

@Component({
  tag: 'lar-slider',
  styleUrl: 'slider.scss',
  shadow: true
})
export class LarvaSlider {
  @Element() el!: HTMLElement;
  /**
   * Emitted when the value property has changed.
   */
  @Event() larchange!: EventEmitter<SliderInputChangeEvent>;

  /**
   * The color to use from your application's color palette.
   * Default options are: `"primary"`, `"secondary"`, `"tertiary"`, `"success"`, `"warning"`, `"danger"`, `"light"`, `"medium"`, and `"dark"`.
   */
  @Prop() color?: Color;
  /**
   * size
   */
  @Prop() orientation?: ('vertical' | 'horizontal') = 'horizontal';
  /**
   */
  @Prop({ mutable: true }) value?: number = 0;
  /**
   */
  @Prop({ mutable: true }) step?: number = 1;
  /**
   */
  @Prop({ mutable: true }) min?: number = 0;
  /**
   */
  @Prop({ mutable: true }) max?: number = 100;

  /**
   * Emitted when the toggle has focus.
   */
  @Event() larfocus!: EventEmitter<void>;

  /**
   * Emitted when the toggle loses focus.
   */
  @Event() larblur!: EventEmitter<void>;

  private onChange = (ev: Event) => {
    this.value = parseFloat((ev.target as any).value);
    this.larchange.emit({ value: this.value });
  }

  private onFocus = () => {
    this.larfocus.emit();
  }

  private onBlur = () => {
    this.larblur.emit();
  }

  /**
   * If `true`, the user cannot interact with the button.
   */
  @Prop({ reflect: true }) disabled = false;

  render() {
    return (
      <Host
        class={{
        ...createColorClasses(this.color),
        'lar-slider': true,
        'lar-slider-disabled': this.disabled,
        'lar-slider-vertical': this.orientation === 'vertical',
        'lar-slider-horizontal': this.orientation === 'horizontal',
        }}
      >
        <input
          onInput={this.onChange}
          onFocus={this.onFocus}
          onMouseUp={this.onBlur}
          onTouchEnd={this.onBlur}
          type="range"
          min={this.min}
          step={this.step}
          max={this.max}
          value={this.value}
          disabled={this.disabled}
        />
      </Host>
    );
  }
}
